export { InsureesView as default } from './insurees-view';
